import midAutumn from '@/views/act/midAutumnAccum2026/assets/locales/hk.js'
import halloween from '@/views/act/halloween/assets/locale/hk.js'
import novShopping from '@/views/act/novShopping2026/assets/locales/hk.js'
export default {
  midAutumn,
  halloween,
  novShopping,
  "props": {
    "80102004": "點券抵用券",
    "90501249": "稱號-月滿中秋",
    "80202003": "槍械三階升級卡",
    "70100101": "金鑽",
    "80102101": "金鑽抽獎券",
    "70100004": "點券",
    "1010504001": "P90-枯骨生花 5天",
    "10101059": "M762-玉面玄狐 7天",
    "10101048": "Groza-幻彩靈駒 7天",
    "80103001": "排位保護卡",
    "80103002": "排位雙倍加分卡",
    "70100011": "金幣",
    "70100014": "秘寶鑰匙",
    "81010999": "萬能成長幣",
    "70100013": "秘寶券",
    "50120500": "池塘盛夏 繪芽",
    "90301912": "[頭像框]傳奇大富翁",
    "90501246": "[稱號]傳奇大富翁",
    "90301913": "[頭像框]超級大富翁",
    "90501247": "[稱號]超級大富翁",
    "90301914": "[頭像框]大富翁",
    "90501248": "[稱號]大富翁",
    "70100012": "秘寶石",
    "32701009": "高級全裝包",
    "70301008": "骰子",
    "90301917": "限定頭像框-[購物達人]"
  },
  "payment": {
    "popupEvent": {
      "joinImmediate": "立即參與",
      "noMoreTip": "今天不再提醒"
    },
    "videoIntro": "彩鑽是遊戲內的通用貨幣，可以在購買有遊戲內任何付費禮包時直接扣除，無需再次現金支付！\n\n彩鑽價值和遊戲現金支付完全相同， 購買彩鑽會有額外贈送！\n\n範例：遊戲內價值330TWD/78HKD的禮包，也可以同樣使用價值330TWD/78HKD的彩鑽購買，並且儲值價值330TWD/78HKD的彩鑽會額外贈送10%彩鑽。\n\nTips：首次儲值彩鑽，最高額外贈送100%！",
    "post": {
      "title": "更多內容",
      "announcement": "公告",
      "faq": "常見問題"
    },
    "howToCheckUserId": "如何查看角色ID",
    "title": "官方儲值，豪禮加贈",
    "noData": "暫無數據",
    "tip": "提醒",
    "notStart": "活動尚未開始",
    "ended": "已結束",
    "maintainTip": "此支付通道正在維護,請稍後再進行嘗試",
    "validateUser": {
      "title": "帳號角色驗證",
      "enterUserId": "請輸入角色Id",
      "desc": "角色id",
      "submit": "查詢",
      "noUserText": "請先查詢並確認用戶資訊",
      "queryLimitExceeded": "您的查詢次數過多，請稍後再試",
      "userNotFound": "角色ID不存在，請檢查後重新輸入。 （點擊問號取得角色ID查看提示）"
    },
    "userDialog": {
      "id": "角色id",
      "name": "角色暱稱",
      "confirmText": "請確認您的帳號資訊",
      "confirmInput": "確認",
      "cancelInput": "重新輸入"
    },
    "payStatusDialog": {
      "cancelText": "取消",
      "paySuccess": "儲值已完成！",
      "payFailed": "儲值失敗",
      "paying": "查詢中"
    },
    "mallGuideDialog": {
      "title": "儲值成功",
      "desc": "您已完成本次彩鑽充值，立即前往會員商城領取您的獎勵吧！",
      "claimLater": "稍後領取",
      "goNow": "立即前往"
    },
    "paymentMethod": {
      "title": "選擇付款方式",
      "recommend": "推薦",
      "moreMethod": "其他支付方式",
      "confirm": "確認",
      "diankaTip1": "Lưu ý: 1 KC Sắc Màu = 250 VND. Sau khi nạp thành công, KC Sắc Màu sẽ được gửi thẳng tới tài khoản của bạn, tương ứng theo mệnh giá thẻ nạp bạn lựa chọn.",
      "diankaTip2": "Vui lòng chọn đúng mệnh giá thẻ nạp của bạn. Nếu chọn sai mệnh giá, bạn sẽ không thể lấy lại được phần chênh lệch. Trang này chỉ cung cấp dịch vụ thanh toán và sẽ không chịu trách nhiệm bồi hoàn khi người chơi chọn sai mệnh giá."
    },
    "product": {
      "title": "選擇儲值禮包",
      "gift-single": "贈送",
      "gift": "贈送",
      "giftRegular": "常規贈送",
      "giftActivity": "新用戶額外贈送",
      "giftActivityBadge": "新用戶額外贈送 {num}",
      "giftRegularBadge": "贈送{num}彩鑽",
      "giftPointsBadge": "贈送{num}積分",
      "coinTotal": "共{total} ({coin}+{gift})",
      "coinTotalOnly": "共{total}",
      "remaining": "剩餘 {num} 次",
      "points": "積分",
      "summary": "信息匯總",
      "selected": "已選擇禮包",
      "diamond": "彩鑽",
      "total": "總價",
      "confirm": "確認",
      "limit": "限購次数"
    }
  },
  "header": {
    "memberStore": "會員商城"
  },
  "tabbar": {
    "recharge": "儲值",
    "pointsMall": "積分商城"
  },
  "footer": {
    "link": {
      "privacy": "使用者協定",
      "security": "隱私權政策"
    },
    "jumpLink": {
      "fb": "https://www.facebook.com/profile.php?id=100088954611977",
      "fbGroup": "https://www.facebook.com/groups/1555503794951354",
      "dc": "",
      "yt": "https://www.youtube.com/{'@'}MWR-TWHKMO",
      "tt": "",
      "privacy": "https://www.miniworldroyale.com/zh-hant/terms/11",
      "security": "https://www.miniworldroyale.com/zh-hant/terms/10"
    },
    "text": "如果您在付款過程中遇到任何問題，可以發送郵件到ministarcustomerservice{'@'}gmail.com聯絡客服為您解決"
  },
  "customerServiceText": "請透過信箱ministarcustomerservice{'@'}gmail.com聯絡我們",
  "cancelText": "傳回儲值",
  "api": {
    "networkError": "網路錯誤",
    "serverError": "伺服器錯誤，錯誤碼："
  },
  "poolParty": {
    "box1": "稀有寶箱",
    "box2": "豪華寶箱",
    "loginDialog": {
      "title": "驗證角色即可领取見面禮"
    },
    "prop": {
      "ACTIVITY_SWIM_RING": "游泳圈",
      "ACTIVITY_WATER_GUN": "噴水槍",
      "ACTIVITY_SUN_UMBRELLA": "太陽傘",
      "ACTIVITY_SWIM_GOGGLES": "泳鏡",
      "80202003": "槍械三階升級卡",
      "70100101": "金鑽",
      "80102101": "金鑽抽獎券",
      "80102004": "點券抵用券",
      "80103001": "排位保護卡",
      "80103002": "排位雙倍加分卡",
      "70100011": "金幣",
      "70100014": "秘寶鑰匙",
      "70100013": "秘寶券",
      "81010999": "萬能成長幣",
      "90301907": "[限定獎勵]頭像框-泳池派對"
    },
    "record": {
      "title": "得獎記錄",
      "detailTitle": "獎勵明細",
      "dateTitle": "領取時間",
      "noData": "暫無數據"
    },
    "btnCanReceive": "可領取",
    "btnReceived": "已領取",
    "btnNotReach": "未達成",
    "goRecharge": "前往儲值",
    "welcomeReward": {
      "title": "見面禮",
      "desc": "完成角色驗證即可領取"
    },
    "exchange": {
      "desc1": "集齊所有泳池派對道具，即可免費獲得活動限定獎勵頭像框-泳池派對。",
      "desc2": "活動期間累計儲值彩鑽達到1000/2000/3000時，可以額外領取一個未擁有的泳池派對道具。",
      "mainPropName": "[限定獎勵]頭像框-泳池派對"
    },
    "dailyReward": {
      "day": "第{day}天",
      "desc": "每天首次儲值彩鑽後，可以解鎖一個寶箱。"
    },
    "accumReward": {
      "itemTitle": "泳池派對禮包",
      "itemCountText": "累計儲值彩鑽達到 {need}({current}/{need})",
      "randomProp": "隨機泳池派對道具",
      "randomPropNotOwned": "隨機泳池派對道具（未擁有）"
    },
    "rule": {
      "item1": "1. 活動期間，每天首次儲值彩鑽，即可領取一個寶箱，寶箱內包含遊戲內道具獎勵和一個活動專屬泳池派對道具",
      "item2": "2. 泳池派對道具共有4種，包含游泳圈，噴水槍，太陽傘和泳鏡，僅限本次活動頁面使用，集齊4種不同的泳池派對道具，即可獲得本次活動限定獎勵頭像框-泳池派對。",
      "item3": "3. 第3/7個寶箱為豪華寶箱，擁有更多遊戲內道具，且必定開出之前未擁有的泳池派對道具。",
      "item4": "4.活動期間累計儲值彩鑽數量達到1000/2000/3000時，即可解鎖額外的泳池派對禮包，打開後必定獲得一個未擁有的泳池派對道具。",
      "item5": "5. 本次活動相關解釋權歸主辦方所有。",
      "item6": ""
    }
  },
  "accumRecharge": {
    "countDownTitle": "活動開始倒計時",
    "countFuhao": "*",
    "clickHere": "點此前往",
    "introduce": "前往線上儲值頁面 [clickHere] ,儲值500/1000/2500/5000/10000檔位彩鑽，即可獲得對應獎勵\n活動時間：2025/9/19 00:00:00 - 2025/10/6 23:59:59(UTC+8)\n獎勵領取時間將於2025/10/12 23:59:59（UTC+8）截止",
    "goRecharge": "前往儲值",
    "rewards": {
      "goRecharge": "前往儲值",
      "record": "得獎記錄",
      "rewardsAll": "一鍵領取",
      "rewardTimes": "領取次數:",
      "btnStatus": {
        "canReceive": "可領取",
        "received": "已領取",
        "goRecharge": "前往儲值"
      },
      "recordTable": {
        "name": "儲值檔位",
        "details": "獎勵明細",
        "time": "領取時間"
      }
    },
    "rule": {
      "title": "活动详细规则:",
      "content": "1.如何儲值：點選上方[goRecharge]按鈕，即可前往線上儲值頁面，請註意選擇活動要求的檔位才能參與喔！\n2.如何兌獎：儲值活動檔位後，點選上方領取獎勵按鈕會自動領取獎勵到遊戲內，可透過信件直接誒領取獎勵。\n3.獎勵獲得次數：每個活動檔位可獲得的獎勵次數有上限，具體次數請查看下方【獎勵领取次数】表，超出指定次數的儲值無法獲得額外獎勵。"
    },
    "rewardsAllDialog": {
      "content": "一鍵領取成功！\n可前往【得獎紀錄】查看獎勵詳情"
    },
    "rewardsTimes": {
      "times": "次"
    }
  },
  "accum": {
    "actStartCountDown": "活動開始倒計時",
    "actEndCountDown": "活動結束倒計時",
    "rewardEndCountDown": "獎勵領取倒計時",
    "actEnded": "活動已結束",
    "clickHere": "點此前往",
    "goRecharge": "前往儲值",
    "record": "得獎記錄",
    "rewardsAll": "一鍵領取",
    "rewards": {
      "eventDesc": "使用官方儲值管道[{clickHere}]，累計儲值彩鑽數量達到100/300/500/1000/2000/3000/5000/10000，即可免費領取獎勵（僅計算基礎彩鑽數量，不計算額外贈送彩鑽數量）",
      "eventDescDuojin": "本次活動獎勵加碼！額外增加全新模式{duojin}玩法獎勵，快來獲取吧！",
      "duojin": "[迷境奪金]",
      "eventTime": "活動時間：2026年06月12日01:00 - 2026年06月22日00:59 (GMT+8)",
      "rewardEndTime": "獎勵領取時間將於2026年06月29日00:59 (GMT+8)截止",
      "diffDiamond": "還差[diamondNum]個彩鑽可領取下一個獎勵",
      "btnCanReceive": "可領取",
      "btnReceived": "已領取",
      "btnNotReach": "未達成",
      "canReceiveAll": "您可領取全部獎勵"
    },
    "rewardsAllDialog": {
      "title": "恭喜您獲得獎勵",
      "content": "一鍵領取成功！\n可前往[record]查看獎勵詳情"
    },
    "recordDialog": {
      "title": "得獎記錄",
      "reachNode": "儲值记录",
      "details": "獎勵明細",
      "time": "領取時間",
      "noData": "暫無數據"
    },
    "rule": {
      "content": "1. 如何儲值：\n點選上方{goRecharge}按鈕，即可前往官方儲值平台進行彩鑽儲值！\n\n2. 如何領獎：\n累計儲值數量達到可領獎檔位時，點選領獎，獎勵會以郵件的形式發放進遊戲內，記得去遊戲內郵箱領取獎勵喔。\n\n3. 每個累儲檔位獎勵僅可領取一次，不可重復領取。\n\n4. 一切活動內容請以頁面實際展示為準，本活動最終解釋權歸官方所有。"
    }
  },
  "cny": {
    "goRecharge": "前往儲值",
    "record": "得獎記錄",
    "remainingTimes": "剩餘抽獎次數",
    "skipAnimation": "跳過抽獎動畫",
    "lotteryOnce": "抽獎1次",
    "lotteryOneKey": "一鍵抽獎",
    "lottery": {
      "desc": "在官方儲值平台，每累計儲值500彩鑽，即可獲得一次幸運轉盤活動次數。\n（注：僅統計儲值的基礎彩鑽數量，不計算額外贈送彩鑽數量。）",
      "times": "儲值統計時間：12月24日 01：00~1月13日 00：59（GMT+8）\n獎勵領取時間：12月24日 01：00~1月19日 00：59（GMT+8）"
    },
    "lotteryRewardDialog": {
      "title": "恭喜您獲得獎勵"
    },
    "rewards": {
      "times": "儲值統計時間：2025年12月22日 00:00-2026年1月12日 00:59 (GMT+7)\n獎勵領取時間：12月22日 00：00~1月18日 23：59（GMT+7）",
      "lotteryNTimes": "抽獎{times}次",
      "reachNode": "獎勵檔位",
      "rewardsAllDialog": {
        "content": "一鍵領取成功！\n可前往【得獎紀錄】查看獎勵詳情"
      }
    },
    "rule": {
      "content": "1. 在活動期間，每在官方儲值平台儲值500彩鑽，即可獲贈一次幸運輪盤抽獎次數。（注：僅統計儲值的基礎彩鑽數量，不計算額外贈送彩鑽數量。）\n2. 在本活動頁面中累積抽獎2、5、10、20、30、50次，可額外領取進度寶箱獎勵。\n3. 儲值統計時間：12月24日 01：00~1月13日 00：59（GMT+8）\t獎勵領取時間：12月24日 01：00~1月19日 00：59（GMT+8）\n4. 本活動最終解釋權歸官方所有。"
    }
  },
  "mwr": {
    "actTimeDialogText": "活動將會在：2月13日 01：00(GMT+8） 正式開啓，敬請期待！",
    "actTimeDialogText2": "",
    "save": "保存",
    "share": "分享",
    "mission": {
      "receiveRewardSuccess": "領取獎勵成功",
      "header": "任務",
      "progress": "進度",
      "btns": {
        "canReceive": "可領取",
        "received": "已領取",
        "notReach": "未達成",
        "shareImmediate": "立即分享"
      },
      "list": {
        "1": {
          "key": "dailyLogin",
          "title": "每日登錄",
          "desc": "每日任務"
        },
        "2": {
          "key": "loginDaysGt3",
          "title": "纍計登錄時間：3天",
          "desc": "一次性任務"
        },
        "3": {
          "key": "loginDaysGt7",
          "title": "纍計登錄時間：7天",
          "desc": "一次性任務"
        },
        "4": {
          "key": "shareMwr",
          "title": "分享至社交媒體",
          "desc": "一次性任務"
        },
        "5": {
          "key": "playedFiveNewMode",
          "title": "玩三種不同的模式",
          "desc": "每日任務"
        },
        "6": {
          "key": "playedFiveNewMode",
          "title": "玩5次新模式",
          "desc": "一次性任務"
        }
      }
    },
    "turn": "攻擊次數",
    "turnNum": "攻擊次數+{num}",
    "logout": "退出",
    "home": {
      "statsPage": {
        "text": "槍戰精英\n2025\n年度報告",
        "btnText": "查看"
      },
      "dragonPage": {
        "text": "成爲\n屠龍勇士\n",
        "btnText": "前往"
      }
    },
    "dragon": {
      "noTurn": "沒有攻擊次數",
      "serverProgress": "全服進度",
      "treasureBox": {
        "notReach": "未達成",
        "received": "已領取"
      },
      "rule": "全服精英需要齊心協力將惡龍擊敗,儅自身對惡龍造成傷害纍計到一定階段時即可獲得寶箱中的獎勵。\n1.每次攻擊惡龍需要消耗一次攻擊次數。\n2.攻擊次數可通過完成任務獲取\n3.儅對惡龍造成的纍計傷害分別達到4052，10130，20260時，與之相對應的進程寶箱將會被解鎖。精英們即可領取寶箱内的獎勵。\n4.開啓寶箱時，精英有概率開出超稀有寶箱，超稀有寶箱的獎勵將會直接替代原有寶箱的獎勵。\n5.超稀有寶箱的開出概率為0.001%，獎勵為19999金鑽。\n6.儅惡龍被擊敗時，將會發放全服獎勵。\n\nFAQ\n1. 本次活動的活動時間是什麼時候？        \n活動開啓和結束時間：2月13日 01：00~3月2日 00：59（GMT+8）\n獎勵領取時間：2月13日 01：00~3月2日 00：59（GMT+8）\n\n2. 活動獎勵如何發放？        \n活動期間的所有獎勵，會透過遊戲內信件發放，請注意查收遊戲內的信箱喔。\n\n3 . 如何對年度報告頁面進行保存截圖？        \n在年度報告頁面的右下角有“保存”選項，點擊后會自動生成截圖，玩家需要長摁圖片進行保存，圖片會保存至手機的圖庫中。\n\n4. 如果巨龍被擊殺了，那我還能參與活動嗎？        \n如果巨龍被擊殺，精英們將無法參與活動，也就無法獲取寶箱了哦~ 所以大家一定要先到先得\n\n5. 活動的獎勵可以重複領取嗎？        \n每個里程碑獎勵僅可領取一次，重複領取不會再獲得相同獎勵。\n\n6. 爲什麽我完成了每日任務，但是卻沒有增加攻擊次數？        \n當您在完成任務后，系統需要三十秒左右的時間來驗證您是否完成了任務，請您耐心等待哦~\n\n7. 若未在領獎期間內領取會怎樣？        \n請務必於3月2日 00：59（GMT+8）前完成領獎。逾期未領取視同放棄，恕不補發。\n\n8. 遇到問題如何聯繫客服？        \n您可發送郵件至 ministarcustomerservice{'@'}gmail.com，並提供您的【角色ID】與【領獎時間】，我們將盡快為您處理。",
      "boxRecord": {
        "title": "歷史記錄",
        "box": "寶箱",
        "reward": "獎勵",
        "time": "獲取時間",
        "box1Name": "寶箱1",
        "box2Name": "寶箱2",
        "box3Name": "寶箱3"
      },
      "superBox": {
        "text1": "巨龍已被擊敗！",
        "text2": "全服獎勵已發送至您的遊戲信箱，記得進入遊戲領取獎勵哦~",
        "text3": "祝精英們新年快樂！"
      }
    },
    "stats": {
      "infos": {
        "page-1-left-title": "你的2025年度報告",
        "page-1-left-desc": "親愛的精英們",
        "page-1-right-title": "解鎖你的2025史詩征程",
        "page-2-left-title": "戰局高光·巔峰時刻",
        "page-2-right-title": "珍藏高光·傳奇典藏",
        "totalGameTime": "游戲總時長",
        "totalKillCount": "一共擊敗玩家數量",
        "alwaysPlayMode": "最常玩的模式",
        "maxRankScore": "達到過的最高段位",
        "maxWeaponId": "使用次數最多的槍械",
        "maxLongWinningCount": "最長的連勝紀錄",
        "maxLongLoginDays": "最長連續登錄時間",
        "topFriendId": "最默契的隊友",
        "totalWeaponCount": "您所擁有的槍械總數",
        "totalAvtCount": "擁有的時裝數量",
        "modeType-1": "槍戰對決",
        "modeType-2": "迷你特訓",
        "modeType-3": "野人突變",
        "hour": "小時",
        "day": "天"
      },
      "chenghao": {
        "isForty": "斷魂奪魄",
        "isTwenty": "毀滅先鋒",
        "isGame100": "弒神者",
        "modeID-1": "戰術大師",
        "modeID-2": "最後的輕語",
        "modeID-3": "狂屠",
        "weaponType-1": "突擊步槍- 破軍之鋒",
        "weaponType-2": "射手步槍 - 審判",
        "weaponType-3": "狙擊步槍 - 天罰",
        "weaponType-4": "輕機槍 - 槍林彈雨",
        "weaponType-5": "衝鋒槍 -  幻影獵手",
        "weaponType-6": "霰彈槍 - 狹間暴君",
        "weaponType-7": "重機槍 - 移動炮臺",
        "weaponType-8": "近戰武器- 神之手",
        "is10WValue": "時尚先鋒",
        "is15WValue": "潮流主宰",
        "is20WValue": "傳奇典範"
      },
      "chenghaoDesc": {
        "isForty": "擊殺率排名前 40% 的玩家",
        "isTwenty": "擊殺率排名前 20% 的玩家",
        "isGame100": "全模式綜合排名前 100",
        "modeID-1": "遊玩次數最多的模式",
        "modeID-2": "遊玩次數最多的模式",
        "modeID-3": "遊玩次數最多的模式",
        "weaponType-1": "最常使用的槍械類型",
        "weaponType-2": "最常使用的槍械類型",
        "weaponType-3": "最常使用的槍械類型",
        "weaponType-4": "最常使用的槍械類型",
        "weaponType-5": "最常使用的槍械類型",
        "weaponType-6": "最常使用的槍械類型",
        "weaponType-7": "最常使用的槍械類型",
        "weaponType-8": "最常使用的槍械類型",
        "is10WValue": "時尚值高於 100,000",
        "is15WValue": "時尚值高於 150,000",
        "is20WValue": "時尚值高於 200,000"
      }
    }
  },
  "sf": {
    "endCountdown": "距離活動結束",
    "startCountdown": "距離活動開始",
    "ended": "活動已結束，請及時領取獎勵",
    "notStart": "活動尚未開始",
    "day": "天",
    "lottery": {
      "desc": "活動期間，在官方儲值平台每累計儲值100彩鑽，就能免費獲得一次「放煙花」的機會。\n每次放煙花後可以獲得一份隨機獎勵，累計放煙花還能領取進度寶箱。\n請注意：儲值僅計算基礎彩鑽數量，不計算額外加贈彩鑽數量。請精英們以基礎數量為準進行計算喔。",
      "times": "儲值統計時間：2月9日 01：00~3月2日 00：59（GMT+8）\n獎勵領取時間：2月9日 01：00~3月9日 00：59（GMT+8）",
      "remainingTimes": "剩餘次數",
      "skipAnimation": "跳過放煙花動畫"
    },
    "lotteryOnce": "放煙花一次",
    "lotteryOneKey": "放完所有煙花",
    "rewards": {
      "desc": "在本活動頁面中累積放煙花2、10、50、100、200次，可額外領取進度寶箱。",
      "canReceiveAll": "您可領取全部獎勵",
      "diffDiamond": "距離下個獎勵還需要放[diamondNum]次煙花",
      "lotteryNTimes": "{times}次"
    },
    "rule": {
      "content": "活動期間\n1、在官方儲值平台每累計儲值100彩鑽，就能免費獲得一次「放煙花」的機會。\n2、每次放煙花後可以獲得一份隨機獎勵，累計放煙花還能領取進度寶箱。\n3、請注意：儲值僅計算基礎彩鑽數量，不計算額外加贈彩鑽數量。請精英們以基礎數量為準進行計算喔。"
    }
  },
  "wc2026": {
    "login": {
      "logintxt": "登錄",
      "inputCode": "請輸入驗證碼",
      "sendCode": "發送游戲內郵箱驗證碼",
      "submit": "確認",
      "cancel": "取消",
      "codeSent": "驗證碼已發送，請在遊戲信箱內查看",
      "loginSuccess": "登入成功",
      "codeError": "登入出錯",
      "emailPlaceholder": "请输入账号",
      "codePlaceholder": "请输入验证码"
    },
    "logout": "【登出】",
    "intro": {
      "title": "活動簡介",
      "contentText": "世界盃應援——選擇你支持的球隊,贏取豐厚獎勵!\r\n完成每日任務即可獲得「應援次數」,在賽程頁面為你看好的球隊送出應援。本屆世界盃共 48 支球隊、橫跨 39 天賽程,應援場次越多,可解鎖的里程碑與排行榜獎勵越豐富。\r\n每日登入,完成任務，持續應援,陪你支持的球隊走到最後!"
    },
    "tabs": {
      "rewardHistory": "獲獎記錄",
      "cheerCountLabel": "我的應援次數:",
      "goEarn": "前往獲得",
      "cheerPowCash": "援力衝擊",
      "toCheer": "應援球隊"
    },
    "rank": {
      "title": "應援達人榜",
      "rank": "排名",
      "nickname": "帳號暱稱",
      "winCount": "勝場次數",
      "des2": "4～10名: 700金鑽 , 11～25名:400金鑽 , 26～50名: 200金鑽",
      "des1": "第1名: 2000金鑽 , 第2名: 1500金鑽 , 第3名: 1000金鑽",
      "awardDes": "活動結束後，累計應援場次前50名玩家均可獲得專屬頭像框及稱號"
    },
    "accountId": "帳號ID",
    "noData": "暫無數據",
    "reaawardName": "獎勵名稱",
    "cheerTime": "應援成功次數",
    "times": "次",
    "bet": {
      "matchResult": {
        "pending": "比賽未開始",
        "cheered": "已應援",
        "draw": "比赛取消",
        "win": "_team勝利",
        "daping": "平局",
        "running": "比賽進行中"
      },
      "selectDate": "赛程",
      "noMatches": "无比赛",
      "cheerSuccess": "應援成功",
      "confirm": {
        "content": "确定应援"
      }
    },
    "backTop": "回到頂部",
    "milestonemainTitle": "參與應援領好禮",
    "milestone": {
      "totalCheer": "應援次數累計獎勵",
      "winCheer": "應援成功累計獎勵",
      "subTitleTotal": "累計應援場次達標即可領取對應獎勵,猜中越多獎勵越豐富!",
      "subTitleWin": "累計應援成功次數達標即可領取對應獎勵,猜中越多獎勵越豐富!",
      "betTarget": "_n次",
      "title1": "應援_N_次",
      "title2": "應援成功_N_次"
    },
    "betTarget": "5次",
    "received": "已領取",
    "canReceive": "可領取",
    "notReach": "未達成",
    "rule": {
      "title": "應援規則詳情",
      "content": "1. 如何送出應援\r\n每場比賽展示兩隊的國旗與隊名,玩家從中選擇一隊送出應援。每場比賽每位玩家限應援 1 次,送出後立即扣除應援次數,且無法取消或修改。\r\n最早可於開賽前 2 天開始應援,每場比賽開始後無法進行應援。\r\n淘汰賽階段規則與小組賽相同,均為選擇一隊應援,淘汰賽不設平局選項。\r\n\r\n2. 結算與獎勵\r\n若應援的球隊獲勝,即為應援成功,可獲得遊戲內道具獎勵。\r\n若比賽打平(僅小組賽可能出現),則應援雙方的玩家都可獲得獎勵。\r\n應援結果以正式比賽最終結果為準。\r\n累計應援場次達到里程碑條件,可獲得對應的里程碑獎勵;應援成功的累計次數將計入排行榜排名。\r\n\r\n3. 注意事項\r\n若比賽因故取消、延期或被判定為無效,該場次所有玩家送出的應援次數將全額退還,不計入應援結果。\r\n若發現以異常手段刷取應援次數或利用漏洞獲益,將扣除異常應援次數並對相關帳號採取封禁等處罰措施。\r\n活動最終解釋權歸運營組所有。"
    },
    "record": {
      "matchTime": "場次",
      "rewards": "獎勵",
      "cheerTime": "應援時間",
      "cheerWinTab": "應援獎勵",
      "milestoneTab": "里程碑獎勵",
      "milestone": "里程碑",
      "receiveTime": "領取時間",
      "target": "目標："
    },
    "share": {
      "text": "分享",
      "title": "已成功應援 _n_ 場並獲得獎勵 ⚽",
      "description": "猜對不是運氣，能贏全靠實力！！！"
    },
    "mail": {
      "title": "【援力衝擊】恭喜您應援成功！",
      "content": "親愛的精英：\r\n\r\n恭喜您在【援力衝擊】活動中應援成功！你支持的隊伍不負眾望拿下了勝利。本場應援獎勵已發放至你的帳戶，請查收。\r\n\r\n祝您遊戲愉快\r\n\r\n迷你槍戰精英運營團隊 敬上"
    },
    "item": {
      "id_70100004": "槍械三階升級卡",
      "id_70100101": "金鑽",
      "id_80102101": "金鑽抽獎券",
      "id_70100011": "金幣",
      "id_32204003": "中級安全箱 (7天）",
      "id_70100014": "秘寶鈅匙",
      "id_81010999": "萬能成長幣",
      "id_90501207": "稱號",
      "id_90301905": "頭像框",
      "id_90105303": "頭像",
      "id_20500901": "準星線-足球",
      "id_20400904": "掛飾-哨子",
      "id_90301906": "頭像框",
      "id_90501208": "稱號"
    },
    "task": {
      "wc_daily_login": "每日登錄",
      "wc_daily_play_mojin1": "完成1場迷境奪金",
      "wc_daily_play_mojin3": "完成3場迷境奪金",
      "wc_daily_play_any3": "完成任意3場比賽",
      "wc_daily_online_60m": "累計在線60分鐘",
      "wc_weekly_share": "分享至社交媒體",
      "daily": "每日任務",
      "weekly": "每週任務"
    },
    "receiveSuccess": "领取成功",
    "milestone,mainTitle": "參與應援領好禮",
    "error": {
      "code1103": "賽事已公佈結果",
      "code1104": "應援時間已截止",
      "code1105": "已應援過該場次",
      "code1106": "應援次數不足",
      "code1202": "獎勵已領取",
      "code1203": "任務未完成",
      "code1302": "里程碑已領取",
      "code1303": "未達到里程碑條件",
      "code1401": "分享太頻繁",
      "code13404": "驗證碼今日獲取次數已達上限",
      "code13405": "驗證碼已過期或不存在",
      "code13406": "今日驗證失敗次數過多，請明日再試或聯絡管理員",
      "code501": "用戶檢查失敗 用戶不存在",
      "code11402": "登入狀態已過期",
      "code429": "請求過於頻繁，請稍後再試"
    },
    "mailveritify_success": "郵箱驗證成功"
  },
  "monopoly": {
    "rule": "活動規則",
    "ruleContent": "1. 本次活動時間為8月15日 01:00~ 8月31日 00:59 (GMT+8)，活動結束後，玩家將無法再透過儲值彩鑽獲得骰子，但仍可使用自己剩餘的骰子，在9月7日00:59分 (GMT+8) 後，將無法使用剩餘的骰子，並結算排行榜。活動頁面將於9月14日00:59 (GMT+8) 徹底關閉。\n2. 活動期間，每日登入活動頁面即可免費領取1枚普通骰子，最多可領取3枚。\n3. 每累計儲值100彩鑽，可獲得1枚普通骰子；每累計儲值1000彩鑽，可額外獲得1枚萬用骰子。\n4. 使用普通骰子後，將隨機擲出1~6點，並依照點數前進對應格數。\n5. 萬用骰子可自由選擇1~6點數，並依照所選點數前進。\n6. 棋盤共有24個格子，完成一圈後將重新從起點繼續前進，並累計圈數。\n7. 落在不同格子可獲得對應獎勵，部分特殊格子將觸發特殊事件，請以實際效果為準。\n8. 完成指定圈數可領取對應圈數獎勵，圈數越高，獎勵越豐富。\n9. 活動結束後，將依據最終累計圈數排行榜發放排名獎勵，請及時領取活動獎勵。\n10. 所有棋盤獎勵需點擊【領取獎勵】後發送至遊戲信箱，活動結束後未領取的獎勵將無法補發。",
    "rewardRecord": "得獎記錄",
    "rewardRecordDialog": {
      "reward": "獎勵",
      "time": "得獎時間",
      "status": "狀態",
      "statusPending": "未領取",
      "statusExtracted": "已領取",
      "statusSent": "已發放",
      "empty": "暫無數據"
    },
    "mainRule": "每日登入頁面即可免費領取一顆骰子，最多可領取3次。\n每儲值100彩鑽，即可獲得一顆骰子。\n每儲值1000彩鑽，可額外獲得獲贈一枚萬用骰子！",
    "logout": "登出",
    "loginTitle": "角色驗證",
    "accountId": "角色ID",
    "login": {
      "logintxt": "【登入】",
      "inputCode": "請輸入驗證碼",
      "sendCode": "發送驗證碼",
      "submit": "確認",
      "cancel": "取消",
      "codeSent": "驗證碼已發送，請在遊戲信箱內查看",
      "loginSuccess": "登入成功",
      "codeError": "登入出錯",
      "emailPlaceholder": "請輸入帳號",
      "codePlaceholder": "請輸入驗證碼"
    },
    "normalDiceNum": "普通骰子 剩餘{num}個",
    "universalDiceNum": "萬用骰子 剩餘{num}個",
    "throwOnce": "投擲1個",
    "throwAll": "投擲所有骰子",
    "pleaseLogin": "請先登入",
    "noDiceTitle": "您已經用光了所有骰子",
    "noDiceTip1": "每儲值{amount}彩鑽，即可取得一顆{dice}",
    "noDiceTip2": "每儲值{amount}彩鑽，可額外獲得獲贈一枚{dice}！",
    "noDiceNormal": "骰子",
    "noDiceUniversal": "萬用骰子",
    "noDiceGoRecharge": "前往儲值",
    "chooseStepsTitle": "請選擇萬能骰子的點數",
    "chooseStepsOption": "前進{steps}格",
    "chooseStepsConfirm": "確認",
    "throwResultUnit": "{steps}點",
    "throwAllRewardTip": "您已使用所有骰子（共 {steps} 格），獲得獎勵",
    "rewardTitle": "恭喜你獲得",
    "rewardEmpty": "本次未獲得獎勵",
    "mysteryEmptyTitle": "限定角色已獲得，替換為稀有寶箱",
    "boxRewardTitleNormal": "稀有寶箱獎勵",
    "boxRewardTitleLucky": "豪華寶箱獎勵",
    "boxRewardTitleMystery": "週年限定獎勵",
    "confirm": "確認",
    "dailyDiceClaimSuccess": "普通骰子+1",
    "dailyDiceTipPrefix": "每日登入可免費獲得一顆骰子，最多可領取",
    "dailyDiceTipSuffix": "次",
    "dailyDiceRemainPrefix": "剩餘領取次數：",
    "dailyDiceClaim": "領取",
    "extractRewards": "領取獎勵",
    "extractRewardsDesc": "點擊按鈕後，可領取獲得的所有獎勵到遊戲信箱內！",
    "extractSuccessTitle": "獎勵已發送到遊戲信箱內",
    "noPendingRewards": "暫無可領取獎勵",
    "circleRewards": "累計完成圈數，獲得更多獎勵",
    "circleAccumulated": "已累計 {count}圈",
    "circleLaps": "{count}圈",
    "lapRewardAlready": "獎勵已領取",
    "lapRewardNotReached": "尚未達到該圈數",
    "ranking": "圈數排行榜",
    "rankingTable": {
      "rank": "排名",
      "nickname": "角色暱稱",
      "laps": "圈數",
      "time": "達成時間（GMT+7）"
    },
    "rankingEmptyNickname": "虛位以待",
    "rankingRewardTitleSingle": "第{rank}名獎勵",
    "rankingRewardTitleRange": "第{min}-{max}名獎勵",
    "moveSteps": "前進{steps}格",
    "moveStepsBack": "倒退{steps}格",
    "moveStepsCastle": "城堡格\n直達{steps}格",
    "notStart": "活動尚未開始",
    "ended": "活動已結束，請及時領取獎勵",
    "startCountdown": "距離活動開始",
    "rechargeCountDown": "儲值贈送骰子剩餘時間",
    "diceCountDown": "骰子使用剩餘時間",
    "countDownNotStarted": "尚未開始",
    "countDownEnded": "已結束",
    "day": "天",
    "error": {
      "code401": "登入狀態已過期",
      "code429": "請求過於頻繁，請稍後再試",
      "code2001": "活動尚未開始",
      "code2002": "活動已結束",
      "code2003": "領獎時間已結束",
      "code2004": "活動已結束",
      "code2801": "今日骰子已領取",
      "code2802": "每日骰子領取次數已達上限",
      "code2803": "當前不可領取每日骰子",
      "code2901": "您已經用光了所有骰子",
      "code2902": "骰子類型無效",
      "code2903": "點數選擇無效",
      "code2904": "萬用骰子不支持投擲全部",
      "code3001": "暫無可領取獎勵",
      "code3002": "領取失敗，請稍後再試",
      "code3101": "尚未達到該圈數",
      "code3102": "獎勵已領取",
      "code3201": "排行榜尚未結算",
      "code3202": "排名獎勵已發放"
    }
  },
  "ann2026": {
    "title": "週年慶點火計劃",
    "flamePower": "火力值",
    "item": {
      "70100004": "點券",
      "80102101": "金鑽抽獎券",
      "70100011": "金幣",
      "70100014": "秘寶鈅匙",
      "70100013": "秘寶券",
      "10101404": "AN94-桂花",
      "50111700": "聖雲",
      "80103001": "排位保護卡",
      "1010102006": "M4-萌動出擊",
      "32701006": "高級裝備禮包",
      "90301910": "【頭像框】週年慶典",
      "90301911": "【頭像框】烈焰風暴",
      "90501244": "【稱號】不滅之火",
      "90501245": "【稱號】餘燼重燃",
      "81010999": "萬能成長幣",
      "TBD_avatar_frame": "【頭像框】週年慶典",
      "TBD_title": "周年慶典",
      "TBD_pendant": "掛飾-哨子"
    },
    "home": {
      "serverPower": "全服火力值"
    },
    "hero": {
      "howToPlay": "活動簡介",
      "logout": "【登出】",
      "login": "【登入】"
    },
    "contribute": {
      "btnMain": "投入火力",
      "desc1": "集結火力，點亮週年蛋糕！",
      "desc2": "可投入火力值：_n",
      "tabSupply": "火力補給",
      "tabRally": "精英集結!",
      "tabHistory": "獲獎記錄"
    },
    "dialog": {
      "close": "關閉"
    },
    "flameSupply": {
      "title": "火力補給",
      "subtitle": "完成任務獲得火力",
      "claimed": "已領取",
      "completed": "可領取",
      "incomplete": "未完成"
    },
    "eliteRally": {
      "subtitle": "邀請好友回歸贏取獎勵",
      "inviteOne": "邀請 1 位好友",
      "inviteMany": "邀請 {count} 位好友",
      "claimed": "已領取",
      "claim": "領取",
      "locked": "未解鎖",
      "itemName": "道具名稱"
    },
    "rewardHistory": {
      "title": "獲獎記錄",
      "reward": "獎勵",
      "receivedAt": "領取時間"
    },
    "congratulation": {
      "receivedReward": "生日快樂!!!"
    },
    "howToPlay": {
      "body": "🎉 火力全開 · 週年慶點火計劃\n邪惡的暗星趁著慶典夜偷襲,吹熄了週年蛋糕上的蠟燭!湯姆、諾娜、凌羽召集全服精英——集結火力,一層層重新點亮蛋糕,點燃象徵一週年的「1」,為迷你槍戰精英慶生!\n\n📅 活動時間\n 參與時間:8月15日 – 9月6日(GMT+7)\n 領獎/兌換:活動開始至 9月13日(GMT+7)\n ※ 請務必在領獎期內領取,逾期視為放棄。\n\n🔥 怎麼玩?三步點亮蛋糕\n第一步:拿點亮次數\n 進入「火力補給」,完成每日任務即可獲得點亮次數:\n 每天記得回來,次數攢得越多,能點亮的火力越多!\n\n第二步:投入火力,點亮蛋糕\n 把點亮次數投入「全服火力值進度條」。你的每一次投入,都會匯入全服的總火力!全服玩家一起,把三層蛋糕從熄滅點回明亮。\n\n第三步:解鎖獎勵\n 全服獎勵:全服火力達到 25% / 50% / 75% / 100% 時,點亮對應蛋糕層,所有參與的玩家一起解鎖獎勵!火力集滿、點燃頂端的「1」,全員領終極大禮 + 週年專屬頭像框和稱號!\n 個人獎勵:你自己累計投入的點亮次數,還能額外解鎖個人里程碑獎勵——投得越多,拿得越多!\n\n🤝 精英集結:召回老友,一起慶生\n 進入「精英集結」召回許久未見的老朋友回歸戰場。召回越多好友,獎勵越豐厚,召回達標還能拿專屬頭像框和稱號!老朋友回家,一起慶生才熱鬧!\n\n🏆 我的記錄\n 所有領取過的獎勵,都能在「領獎記錄」裡查看。"
    },
    "powerContributed": {
      "text": "已投入火力：{count}"
    },
    "task": {
      "ann_daily_login": "每日登錄",
      "ann_daily_mojin_1": "完成1次迷境奪金",
      "ann_daily_mojin_3": "完成3次迷境奪金",
      "ann_daily_play_any_1": "完成1次任意模式",
      "ann_weekly_share": "分享到社交媒體",
      "ann_weekly_mojin_cake": "獲得迷境奪金紅色物品：週年蛋糕",
      "dailyLabel": "每日任務",
      "weeklyLabel": "每週任務"
    },
    "milestone": {
      "times": "_n 次",
      "claim": "可領取",
      "claimed": "已領取",
      "notAchieved": "未達成",
      "reward_1": "頭像框",
      "reward_2": "10000點卡",
      "reward_3": "2張金鑽抽獎券",
      "reward_4": "稱號",
      "reward_5": "30神秘代金券",
      "reward_6": "3張金鑽抽獎券",
      "reward_7": "600萬金幣",
      "reward_8": "3張金鑽抽獎券",
      "reward_9": "吊墜",
      "reward_10": "1把神秘鑰匙",
      "reward_11": "AN94"
    },
    "footer": {
      "privacyPolicy": "隱私權政策",
      "userAgreement": "使用者協定",
      "customerService": "請透過信箱 ministarcustomerservice{'@'}gmail.com 聯絡我們"
    },
    "accountId": "帳號ID",
    "logout": "登出",
    "needLogin": "請先登入後再參與活動",
    "phase": "活動階段",
    "timeRange": "可參與時間",
    "availableFire": "可用點火次數",
    "totalFire": "累計投入火力",
    "ignite": "投入火力",
    "share": "分享",
    "firstLoginReward": "領取首次登入禮",
    "refresh": "刷新",
    "receive": "領取",
    "received": "已領取",
    "notReady": "未完成",
    "unlocked": "已解鎖",
    "locked": "未解鎖",
    "recallCount": "召回人數",
    "igniteOk": "投入成功，消耗",
    "shareOk": "分享成功",
    "receiveOk": "领取成功",
    "section": {
      "activity": "活動資訊",
      "fire": "我的火力",
      "global": "全服節點",
      "task": "任務",
      "milestone": "火力里程碑",
      "recall": "精英集結",
      "record": "領獎記錄"
    },
    "login": {
      "logintxt": "登入",
      "inputCode": "驗證碼",
      "sendCode": "發送驗證碼",
      "submit": "確認",
      "cancel": "取消",
      "codeSent": "驗證碼已發送至遊戲信箱",
      "loginSuccess": "登入成功",
      "emailVerificationSuccess": "郵箱驗證成功",
      "birthday": "生日快樂!!!",
      "codeError": "登入失敗",
      "emailPlaceholder": "請輸入帳號",
      "codePlaceholder": "請輸入驗證碼",
      "accountLabel": "帳號ID",
      "codeLabel": "驗證碼"
    },
    "error": {
      "code401": "登入狀態已過期",
      "code2201": "任務未完成",
      "code2202": "獎勵已領取",
      "code2301": "火力值不足",
      "code2401": "節點尚未解鎖",
      "code2402": "獎勵已領取",
      "code2501": "未達到里程碑條件",
      "code2502": "獎勵已領取",
      "code2601": "召回人數不足",
      "code2602": "獎勵已領取",
      "code2801": "獎勵已領取",
      "code2001": "活動尚未開始",
      "code2002": "活動已結束",
      "code429": "請求過於頻繁"
    }
  }
}
